import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Step2Response } from "../../api/types/step2"

type initialState = {
    response: Step2Response | null
}

const step2Slice = createSlice({
    name: "step2",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.step2.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default step2Slice.reducer
